export const YOUTUBE_DEBUG_STEPS = [
  {
    number: "01",
    slug: "01-debug-embeded-yt-stream",
    label: "Plain iframe",
    description: "YouTube embed with no wrapper transforms or Babylon scene.",
  },
  {
    number: "02",
    slug: "02-debug-embeded-yt-stream",
    label: "CSS transform",
    description: "The same iframe inside a perspective-transformed HTML element.",
  },
  {
    number: "03",
    slug: "03-debug-embeded-yt-stream",
    label: "Babylon + DOM",
    description: "A normal iframe overlay inside a minimal Babylon viewport.",
  },
  {
    number: "04",
    slug: "04-debug-embeded-yt-stream",
    label: "Animated HtmlMesh",
    description: "The iframe mapped into animated Babylon 3-space with HtmlMesh.",
  },
] as const;

export type YouTubeDebugStep = (typeof YOUTUBE_DEBUG_STEPS)[number];

export function getYouTubeDebugPath(step: YouTubeDebugStep, videoId?: string | null) {
  const pathname = `/debugging/${step.slug}`;
  if (!videoId) return pathname;
  const search = new URLSearchParams({ youtube: videoId });
  return `${pathname}?${search.toString()}`;
}
